import { render, staticRenderFns } from "./Historique.vue?vue&type=template&id=04c79a2e"
import script from "./Historique.vue?vue&type=script&lang=js"
export * from "./Historique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports